module.exports = __webpack_public_path__ + "img/sdk.43de5748.png";